import api from './api';
import type {
  EsmsOverview, EsmsTrendRow, EsmsGroupBy,
  EsmsBrandname, EsmsZaloOA, EsmsTopRecipient, EsmsPriceReference,
  EsmsTrendByTypeResponse, EsmsMessage, EsmsOtpStats,
} from '../types/esms';

interface DateRangeParams { from: string; to: string }

export const esmsApi = {
  async getOverview(p: DateRangeParams): Promise<EsmsOverview> {
    const { data } = await api.get('/esms/overview', { params: p });
    return data;
  },
  async getTrend(p: DateRangeParams & { groupBy?: EsmsGroupBy }): Promise<EsmsTrendRow[]> {
    const { data } = await api.get('/esms/trend', { params: p });
    return data;
  },
  async getTrendByType(from: string, to: string, groupBy: EsmsGroupBy): Promise<EsmsTrendByTypeResponse> {
    const { data } = await api.get('/esms/trend-by-type', { params: { from, to, groupBy } });
    return data;
  },
  async getBrandnames(from: string, to: string): Promise<{ brandnames: EsmsBrandname[] }> {
    const { data } = await api.get('/esms/brandnames', { params: { from, to } });
    return data;
  },
  async getZaloOA(): Promise<{ oas: EsmsZaloOA[] }> {
    const { data } = await api.get('/esms/zalo-oa');
    return data;
  },
  async getTopRecipients(from: string, to: string, limit?: number): Promise<{ recipients: EsmsTopRecipient[]; limit: number }> {
    const { data } = await api.get('/esms/top-recipients', { params: { from, to, limit } });
    return data;
  },
  async getPriceReference(): Promise<EsmsPriceReference> {
    const { data } = await api.get('/esms/price-reference');
    return data;
  },
  async getOtpStats(from: string, to: string, prefix?: string): Promise<EsmsOtpStats> {
    const { data } = await api.get('/esms/otp-stats', { params: { from, to, prefix } });
    return data;
  },
  async getMessagesByPhone(phone: string, from: string, to: string): Promise<{ phone: string; messages: EsmsMessage[] }> {
    const { data } = await api.get('/esms/messages-by-phone', { params: { phone, from, to } });
    return data;
  },
  async sync(p: DateRangeParams & { reset?: boolean }): Promise<{ ok: boolean }> {
    const { data } = await api.post('/esms/sync', null, { params: { from: p.from, to: p.to, reset: p.reset ? 1 : undefined } });
    return data;
  },
};
